import { get } from 'lodash';
import { EnumSortOrder } from '../constants/enum';
import { convertPriceToValue } from './utils';

export const sortStringFunction = (nestedField, sortOrder) => (
  (a, b) => {
    const processedA = (get(a, nestedField) || '').trim();
    const processedB = (get(b, nestedField) || '').trim();

    return (
      processedA.localeCompare(processedB) *
      (sortOrder === EnumSortOrder.ASC.id ? 1 : -1)
    )
  }
);

export const sortNumberFunction = (nestedField, sortOrder) => (
  (a, b) => (
    (get(a, nestedField) - get(b, nestedField)) *
    (sortOrder === EnumSortOrder.ASC.id ? 1 : -1)
  )
);

export const sortStringMoneyFunction = (nestedField, sortOrder) => (
  (a, b) => (
    (convertPriceToValue(get(a, nestedField)) - convertPriceToValue(get(b, nestedField))) *
    (sortOrder === EnumSortOrder.ASC.id ? 1 : -1)
  )
);

export const sortCustomFunction = (getFieldFunction, compareFunction, sortOrder) => (
  (a, b) => (
    compareFunction(getFieldFunction(a), getFieldFunction(b)) *
    (sortOrder === EnumSortOrder.ASC.id ? 1 : -1)
  )
);

const revertSortOrder = (sortOrder) => (
  sortOrder === EnumSortOrder.DESC.id
    ? EnumSortOrder.ASC.id
    : EnumSortOrder.DESC.id
);

export const getSortData = (oldSort, newSort, sortOrder) => (
  {
    sort: newSort,
    ...(
      newSort !== oldSort
        ? { sortOrder: EnumSortOrder.DESC.id }
        : { sortOrder: revertSortOrder(sortOrder) }
    )
  }
);


// WEBPACK FOOTER //
// ./foody/src/utils/sort.js